import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative expanded"
}
const _hoisted_2 = { class: "w-full mx-auto pt-2" }
const _hoisted_3 = {
  key: 1,
  class: "w-full flex pb-4 pt-1 mt-1 mb-1"
}
const _hoisted_4 = { class: "content-end" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex items-center ml-6 py-1.5" }
const _hoisted_7 = { class: "w-full h-min sm:h-48 sm:h-min" }
const _hoisted_8 = { class: "flex relative" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "overflow-hidden flex w-full h-auto lg:flex-nowrap flex-wrap" }
const _hoisted_11 = { class: "w-full mx-auto pt-2" }
const _hoisted_12 = { class: "content-end" }

import { ref, Ref, onMounted } from 'vue';
// import { usePlayApiStore } from "../store/api/playApi";
import { useRealtimeApiStore } from "../store/api/realtimeApi";
import { SquadMember } from '@/models/queryBuilder'
import { GenderEnum, CountryEnum, CodeEnum, Player } from '@/models/vscoreModels'

import { useConfirm } from "primevue/useconfirm";
import Button from 'primevue/button'
import ProgressSpinner from 'primevue/progressspinner'
import Table from '../components/DataTable.vue';
import DataTabs from '../components/DataTabs.vue';
import EditInfo from '../components/EditInformationCard.vue';
import Details from '../components/InformationCard.vue'
import TeamMembersManager from '../components/TeamMembersManager.vue';

// const playApi = usePlayApiStore()

export default /*#__PURE__*/_defineComponent({
  __name: 'TeamManager',
  props: ['selectedTeam', 'limit'],
  emits: ['return', 'changeEditStatus', 'setTableSize'],
  setup(__props, { emit: __emit }) {

const api = useRealtimeApiStore()

const confirm = useConfirm();
const props = __props
const emit = __emit

const state = ref({
    isLoading: true,
    isEditMode: false,
    isNewTeam: Object.keys(props.selectedTeam).length == 0,
    hasWarning: false,
})

const playerColumns = [
    { name: 'ID', key: 'id' },
    { name: 'Name', key: 'name' },
    { name: 'Country', key: 'country' },
    { name: 'Gender', key: 'gender' },
    { name: 'Playing Role', key: 'playingRole' },
    { name: 'Batting Hand', key: 'battingHand' },
    { name: 'Bowling Style', key: 'bowlingStyle' },
    { name: 'Legacy Id', key: 'legacyId' },
    { name: 'Middle Names', key: 'middleNames' },
    { name: 'Nick Names', key: 'nickNames' },
]
const displayColumns = [
    // { name: 'ID', key: 'id' },
    { name: 'Team Name', key: 'name' },
    { name: 'Country', key: 'country' },
    { name: 'Team Code', key: 'teamCode' },
    { name: 'League', key: 'league' },
    { name: 'Gender', key: 'gender' },
]
const playerData: Ref<Player[]> = ref([])

const emptyInfo = {
    data: {
        "Team Name": { value: "", type: "text", required: true },
        "Country": {
            value: "",
            type: "autoComplete",
            options: Object.values(CountryEnum).filter((item) => { return isNaN(Number(item)) }), 
            required: false
        },
        "Team Code": {
            value: '',
            type: "dropdown",
            options: Object.values(CodeEnum).filter((item) => { return isNaN(Number(item)) }), 
            required: false
        },
        "League": { value: "", type: "text", required: false },
        "Gender": {
            value: "",
            type: "dropdown",
            options: Object.values(GenderEnum).filter((item) => { return isNaN(Number(item)) }), 
            required: true
        },
    },
}
const tabHeaders = ["Players"]

let information = ref(JSON.parse(JSON.stringify(emptyInfo)))

const tableOffset = ref(0)
let editableInformation = ref(getInfo())
const tableData = ref()

const teamTotal = ref(0)

onMounted(async () => {
    state.value.isLoading = true
    information.value["image"] = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 512 512'%3E%3Ccircle cx='152' cy='184' r='72' fill='%23243045'/%3E%3Cpath fill='%23243045' d='M234 296c-28.16-14.3-59.24-20-82-20c-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93c11.17-12.68 26.81-24.45 46-34'/%3E%3Cpath fill='%23243045' d='M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96'/%3E%3Ccircle cx='340' cy='168' r='88' fill='%23243045'/%3E%3C/svg%3E"

    if (!state.value.isNewTeam) {
        // TODO
        // Currently pulling from 2023 data
        await api.getSquadByTeamId(props.selectedTeam.id.toString()).then((value) => {
            playerData.value = JSON.parse(value.data).data;
            teamTotal.value = playerData.value.length
            displayColumns.forEach((element: { name: string, key: string }) => {
                information.value.data[element.name].value = props.selectedTeam[element.key]
            });
            resetData()
        })
        emit('setTableSize')
    } else {
        resetData()
        state.value.isEditMode = true
    }
    state.value.isLoading = false
})

/**
 * Remove reactivity from referenced object to ensure unedited state is perserved
 * @returns new copy of data object
 */
function unWrapData() {
    return JSON.parse(JSON.stringify(playerData.value))
}

/**
 * Remove reactivity from referenced object to ensure unedited state is perserved
 * @returns new copy of imformation.data
 */
function getInfo() {
    return JSON.parse(JSON.stringify(information.value.data))
}

const confirmSave = () => {
    validate()
    if (!state.value.hasWarning) {
        confirm.require({
            message: 'Confirm to save',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            rejectLabel: 'Cancel',
            acceptLabel: 'Save',
            accept: () => {
                //save entry
                save()
                emit('changeEditStatus', false)
                state.value.isEditMode = false
                state.value.isNewTeam = false
            }
        });
    }
};

const confirmCancel = () => {
    confirm.require({
        message: 'Are you sure you want to leave? Your changes will be lost',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectLabel: 'No',
        acceptLabel: 'Yes',
        accept: () => {
            state.value.hasWarning = false
            emit('changeEditStatus', false)
            state.value.isEditMode = false
            resetData()
            if (state.value.isNewTeam) {
                emit('return')
            }
        }
    });
};

function validate() {
    state.value.hasWarning = false
    if (editableInformation.value["Team Name"].value == "") {
        state.value.hasWarning = true
    } 
    if (editableInformation.value["Gender"].value == "") {
        state.value.hasWarning = true
    }
}

function resetData() {
    teamTotal.value = playerData.value.length
    editableInformation.value = getInfo()
    tableData.value = unWrapData()
}

async function save() {
    // if team is brand new
    // Create the team
    if (state.value.isNewTeam) {
        // let newTeamId;
        var newTeam: any = {
            "name": editableInformation.value["Team Name"].value,
            "gender": GenderEnum[editableInformation.value["Gender"].value],
        }
        if (editableInformation.value["Team Code"].value !== "")
            newTeam["teamCode"] = editableInformation.value["Team Code"].value
        if (editableInformation.value["Country"].value !== "")
            newTeam["country"] = CountryEnum[editableInformation.value["Country"].value.replaceAll(" ", "").replaceAll("-", "")]
        if (editableInformation.value["League"].value !== "")
            newTeam["league"] = editableInformation.value["League"].value
        let newTeamId: string;
        // API CALL
        // await api.createTeam(newTeam).then((response) => {
        //     state.value.isNewTeam = false
        //     console.log("location: " + response)
        //     // newTeamId = response.split("/")[1]
        // })

        newTeamId = "FAKEID"
        tableData.value.forEach(async (savedMember: Player) => {
            // API CALL
            // await api.addPlayerToTeam(newTeamId, {"playerId": savedMember.id})
        })


    } else {
        // Update the team
        // var updatedTeam = {
        //     "name": editableInformation.value["Team Name"].value,
        //     "country": CountryEnum[(editableInformation.value["Country"].value).replace(" ", "")],
        //     // "level": Level[editableInformation.value["Level"].value],
        //     // "region": editableInformation.value["Region"].value,
        // }
        // // API CALL
        // // await playApi.changeTeamDetails(props.information.id, updatedTeam, null)

        // // Add and update players
        tableData.value.forEach(async (savedMember: Player, index: number) => {
            let savedMemberFound = false
            playerData.value.forEach((previousMember: Player) => {
                if (savedMember.id === previousMember.id) {
                    savedMemberFound = true
                }
            })
            if (!savedMemberFound) {
                // API Call
                // await api.addPlayerToTeam(props.selectedTeam.id, savedMember.id)
                console.log("player added: " + JSON.stringify(savedMember))
            }
        });

        // Remove players
        playerData.value.forEach((previousMember: Player) => {
            let foundPreviousMember = false
            tableData.value.forEach((savedMember: Player) => {
                if (savedMember.id === previousMember.id) {
                    foundPreviousMember = true
                }
            })
            if (!foundPreviousMember) {
                // TODO
                // remove member from team
                // Eiter update player status to retired 
                // or remove squad member from team once there is API support
                console.log("player removed: " + JSON.stringify(previousMember) + " \n Dont have API support for this yet")
            }
        });

    }
    playerData.value = JSON.parse(JSON.stringify(tableData.value))
    information.value.data = JSON.parse(JSON.stringify(editableInformation.value))
    teamTotal.value = playerData.value.length
}

/**
 * Remove item from table - shallow removal
 * Item is only removed from backend data when changes are saved
 * @param item to be removed from table
 */
function removeItem(item: any) {
    tableData.value.forEach(function (element: object, index: number) {
        if (element === item) {
            tableData.value.splice(index, 1)
        }
    })
    teamTotal.value = tableData.value.length
}

/**
 * Add a player to the table
 * Player is only removed from team when changes are saved
 * @param player to be added to table
 */
function addPlayer(player: Player) {
    tableData.value.unshift(player)
    teamTotal.value = tableData.value.length
}


return (_ctx: any,_cache: any) => {
  return (!state.value.isEditMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Button), {
          icon: "pi pi-chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('return'); resetData()}),
          class: "absolute left-0 top-0 mt-1 pl-0 pr-4 w-max",
          "aria-label": "Bookmark"
        }),
        _createVNode(Details, {
          information: _unref(information),
          class: "py-2 pl-4 information",
          "team-total": teamTotal.value
        }, null, 8, ["information", "team-total"]),
        _createVNode(DataTabs, {
          headers: tabHeaders,
          expandedActive: 0,
          parentTabActive: 1,
          class: "mb-3 relative"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (!state.value.isLoading)
                ? (_openBlock(), _createBlock(Table, {
                    key: 0,
                    "is-edit-mode": false,
                    data: playerData.value.slice(tableOffset.value, tableOffset.value + __props.limit),
                    columns: playerColumns,
                    onNextPage: _cache[1] || (_cache[1] = ($event: any) => (tableOffset.value = tableOffset.value + __props.limit)),
                    onPrevPage: _cache[2] || (_cache[2] = ($event: any) => (tableOffset.value = tableOffset.value - __props.limit)),
                    limit: __props.limit,
                    offset: tableOffset.value,
                    "total-count": playerData.value.length
                  }, null, 8, ["data", "limit", "offset", "total-count"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_unref(ProgressSpinner), {
                      class: "justify-center w-90 h-90",
                      "attrs-color-black": "",
                      strokeWidth: "5",
                      animationDuration: "1s",
                      "aria-label": "Loading"
                    })
                  ]))
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          (!state.value.isEditMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = ($event: any) => {state.value.isEditMode = true; _ctx.$emit('changeEditStatus', true)}),
                class: "bg-[#1f2937] hover:bg-slate-500 text-white ml-2 mb-2 mt-0 font-semi h-6 py-0 pb-0.5 rounded w-24 float-right flex items-center justify-center"
              }, " Edit "))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_unref(information).image !== undefined)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(information).image,
                    alt: "Image of team",
                    class: "w-28 h-20 sm:w-auto sm:h-48 self-center mr-8"
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(EditInfo, {
                  information: _unref(editableInformation),
                  "members-total": teamTotal.value,
                  warning: state.value.hasWarning,
                  class: "lg:w-fit w-full h-auto lg:h-full overflow-x-auto"
                }, null, 8, ["information", "members-total", "warning"]),
                _createVNode(TeamMembersManager, {
                  "team-members": tableData.value,
                  onAddPlayer: addPlayer
                }, null, 8, ["team-members"])
              ])
            ])
          ])
        ]),
        _createVNode(DataTabs, {
          headers: tabHeaders,
          class: "mb-3 relative pt-1",
          expandedActive: 0,
          parentTabActive: 1
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(Table, {
                "is-edit-mode": true,
                data: teamTotal.value !== 0 ? tableData.value.slice(tableOffset.value, tableOffset.value + __props.limit) : tableData.value,
                columns: playerColumns,
                onNextPage: _cache[4] || (_cache[4] = ($event: any) => {tableOffset.value = tableOffset.value + __props.limit;}),
                onRemoveItem: removeItem,
                onPrevPage: _cache[5] || (_cache[5] = ($event: any) => (tableOffset.value = tableOffset.value - __props.limit)),
                limit: __props.limit,
                offset: tableOffset.value,
                message: { title: 'No Players', paragraph: 'No current players for this Team' },
                "total-count": tableData.value.length
              }, null, 8, ["data", "limit", "offset", "total-count"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => {confirmSave();}),
            class: "bg-[#1f2937] hover:bg-slate-500 text-white ml-2 mb-2 mt-0 font-semi h-6 py-0 pb-0.5 rounded w-24 float-right flex items-center justify-center"
          }, " Save "),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => {confirmCancel();}),
            class: "border-[#1f2937] border-2 hover:bg-gray-200 text-[#1f2937] ml-2 mb-2 mt-0 font-semi h-6 py-0 pb-0.5 justify-center rounded w-24 float-right flex items-center"
          }, " Cancel ")
        ])
      ]))
}
}

})